export default "__VITE_ASSET__DszKhkTt__ 600w";